import React,{useState, useEffect} from "react";

// import { Divider, Drawer, Space, Button } from "antd";
import { Link } from "react-router-dom";
import Layout from "../../components/layout/Layout";
interface CartItem {
    // Define the structure of each item in your cart
    quantity: number;
    // Other properties if present
  }
  
const ShoppingCard = () => {
    // const [quantity, setQuantity] = useState(1);
    const [cartItems, setCartItems] = useState<CartItem[]>([]);
    useEffect(() => {
        const storedCartData = localStorage.getItem("cart");
        (storedCartData) ? setCartItems(JSON.parse(storedCartData) ) : setCartItems([]);
        console.log("cart items -->",cartItems);
    },[])

  const totalQnty = cartItems
    ?.map((data: any) => data?.quantity)
    ?.reduce((total: number, quantity: number) => (total += quantity), 0);

  const calculateItemTotal = (item: any) => {
    const price = parseFloat(item.price);
    const quantity = parseInt(item.quantity, 10);
    return price * quantity;
  };

  // Calculate the overall cart total
  const cartTotal = cartItems.reduce((total: any, item: any) => {
    return total + calculateItemTotal(item);
  }, 0);

  const handleIncreaseQuantity = (index: any, quantityy: any) => {
    const updatedCart = [...cartItems];
    console.log(updatedCart[index].quantity)
    updatedCart[index].quantity = quantityy + 1; // Update quantity
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    const storedCartData = localStorage.getItem("cart");
    
    (storedCartData) ? setCartItems(JSON.parse(storedCartData) ) : setCartItems([]);
  };

  const handleDecreaseQuantity = (index: any, quantityy: any) => {
    if (quantityy > 1) {
        const updatedCart = [...cartItems];
        updatedCart[index].quantity = quantityy - 1; // Update quantity
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        const storedCartData = localStorage.getItem("cart");
        
        (storedCartData) ? setCartItems(JSON.parse(storedCartData) ) : setCartItems([]);
    }
  };

  const removeItem = (index: any) => {
    const updatedCart = [...cartItems];
    updatedCart.splice(index, 1);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    const storedCartData = localStorage.getItem("cart");
    
    (storedCartData) ? setCartItems(JSON.parse(storedCartData) ) : setCartItems([]);
    // onClose();
  };
  console.log('cart',cartItems);
  return (
    <Layout>
     <div className="cart-table-area section-padding-100">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-lg-8">
                        <div className="cart-title mt-50">
                            <h2>Shopping Cart</h2>
                        </div>

                        <div className="cart-table clearfix">
                            <table className="table table-responsive">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Name</th>
                                        <th>Price</th>
                                        <th>Quantity</th>
                                        <th>Remove</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {cartItems?.map((el: any, index: any) => (
                                    <tr key={index}>
                                        <td className="cart_product_img">
                                            <a href="#"><img src={el?.picture} alt="Product"/></a>
                                        </td>
                                        <td className="cart_product_desc">
                                            <h5>{el?.name}</h5>
                                        </td>
                                        <td className="price">
                                            <span>{`RWF ${el?.price}`}</span>
                                        </td>
                                        <td className="qty">
                                            <div className="qty-btn d-flex">
                                                <p>Qty</p>
                                                <div className="quantity">
                                                    <span className="qty-minus" onClick={() => handleDecreaseQuantity(index, el?.quantity)} ><i className="fa fa-minus" aria-hidden="true"></i></span>
                                                    <input type="number" className="qty-text" id="qty" step="1" min="1" max="300" name="quantity" value={(el?.quantity < 1) ? 1 : el?.quantity}/>
                                                    <span className="qty-plus" onClick={() => handleIncreaseQuantity(index, el?.quantity)}><i className="fa fa-plus" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="price">
                                            <button
                                            className="btn btn-danger"
                                            onClick={() => removeItem(index)}
                                            style={{
                                                width: 45,
                                        
                                                backgroundColor: "transparent"
                                            }}
                                            >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M15.84 22.25H8.16a3.05 3.05 0 0 1-3-2.86L4.25 5.55a.76.76 0 0 1 .2-.55.77.77 0 0 1 .55-.25h14a.75.75 0 0 1 .75.8l-.87 13.84a3.05 3.05 0 0 1-3.04 2.86zm-10-16 .77 13.05a1.55 1.55 0 0 0 1.55 1.45h7.68a1.56 1.56 0 0 0 1.55-1.45l.81-13z"></path>
                                                <path d="M21 6.25H3a.75.75 0 0 1 0-1.5h18a.75.75 0 0 1 0 1.5z"></path>
                                                <path d="M15 6.25H9a.76.76 0 0 1-.75-.75V3.7a2 2 0 0 1 1.95-1.95h3.6a2 2 0 0 1 1.95 2V5.5a.76.76 0 0 1-.75.75zm-5.25-1.5h4.5v-1a.45.45 0 0 0-.45-.45h-3.6a.45.45 0 0 0-.45.45zM15 18.25a.76.76 0 0 1-.75-.75v-8a.75.75 0 0 1 1.5 0v8a.76.76 0 0 1-.75.75zM9 18.25a.76.76 0 0 1-.75-.75v-8a.75.75 0 0 1 1.5 0v8a.76.76 0 0 1-.75.75zM12 18.25a.76.76 0 0 1-.75-.75v-8a.75.75 0 0 1 1.5 0v8a.76.76 0 0 1-.75.75z"></path>
                                            </svg>
                                            </button>
                                    </td>
                                    </tr>
                                    ))}
                                   
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4">
                        <div className="cart-summary">
                            <h5>Cart Total</h5>
                            <ul className="summary-table">
                                <li><span>subtotal:</span> <span>{`RWF ${cartTotal?.toLocaleString()}`}</span></li>
                                {/* <li><span>delivery:</span> <span>Free</span></li> */}
                                <li><span>total:</span> <span>{`RWF ${cartTotal?.toLocaleString()}`}</span></li>
                            </ul>
                            {(cartItems?.length > 0) ? (
                            <div className="cart-btn mt-100">
                                <Link to={"/checkout"} className="btn amado-btn w-100" style={{ textDecoration: 'none' }}>Checkout</Link>
                            </div>) : null}
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
    </Layout>
  );
};

export default ShoppingCard;
